<div class="profile-user-photos wpee-block">
    <div class="wpee-block-header" *ngIf="show_title">
        <h4 class="wpee-block-title">Photos</h4>
    </div>
    <div class="wpee-block-footer" *ngIf="show_title">
        <a class="edit-profile-link" (click)="viewPhotos()" *ngIf="!loader2">View Photos</a>
        <div [ngClass]="{ 'shine': loader2 }">
        </div>
    </div>
    <div class="profile-user-photos-inner wpee-block-content" #scrollContainer>
        <ul class="profile-photo-list no-list d-flex" *ngIf=" !loader">
            <li class="photos-list" *ngFor="let imgs of post_images">
                <a rel="example_group" (click)="openImageModal(imgs.photoUrl)">
                    <span class="image-bg" style="background-image: url('{{imgs.photoUrl}}');"></span>
                </a>
                <div class="close_icon" (click)="removeImg(imgs.photoId)" *ngIf="!show_title && is_myProfile">
                    <img [src]="apiservices.frontendAssetsUrl + 'close.svg'" alt="">
                </div>
            </li>

            <li class="shine up_imgs" *ngIf="!show_title && this.shimmer"></li>
            <li class="shine up_imgs" *ngIf="!show_title && this.shimmer"></li>
            <li class="shine up_imgs" *ngIf="!show_title && this.shimmer"></li>
            <li class="shine up_imgs" *ngIf="!show_title && this.shimmer"></li>
            <li class="shine up_imgs" *ngIf="!show_title && this.shimmer"></li>
            <li class="shine up_imgs" *ngIf="!show_title && this.shimmer"></li>

            <!-- <li class="shine" *ngIf="!show_title && this.shimmer"></li> -->

            <span class="dsp_span_pointer" *ngIf="post_images.length == 0 && show_title && !showErrorMessage">No Photos
                added</span>
            <div class="profile-section-content" *ngIf="post_images.length == 0 && !show_title && !showErrorMessage">
                <div class="photo-list-inner">
                    <div class="profile-user-photos-inner wpee-block-content">
                        <div style="text-align: center; display: grid;" class="wpee-empty-info wpee-info">
                            <span style="color: #FF0000;">
                                The user has not uploaded any photos. </span>
                        </div>
                    </div>
                </div>
            </div>
            <span class="dsp_span_pointer" *ngIf="post_images.length == 0 && show_title && showErrorMessage">Photos is
                private</span>
            <div class="profile-section-content" *ngIf="post_images.length == 0 && !show_title && showErrorMessage">
                <div class="photo-list-inner">
                    <div class="profile-user-photos-inner wpee-block-content">
                        <div style="text-align: center; display: grid;" class="wpee-empty-info wpee-info">
                            <span style="color: #FF0000;">Photos is private</span>
                        </div>
                    </div>
                </div>
            </div>
        </ul>

        
        <div [ngClass]="{ 'shine': loader }">
        </div>
    </div>
</div>